import Image from "next/image";
import Link from "next/link";
import { MapPin, Menu } from "lucide-react";
import { navItems } from "@/lib/site-data";

const items = [...navItems, {href:'/versenyzoi-belepes', label:'Versenyzői belépés', icon:MapPin}];

export function SiteHeader() {
  return (
    <header className="sticky top-0 z-50 border-b border-[#17365d]/10 bg-white/95 backdrop-blur-xl">
      <div className="hidden bg-[#17365d] text-white md:block">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-2 text-xs font-semibold tracking-wide">
          <span className="flex items-center gap-2"><MapPin className="size-3.5 text-[#ef233c]" aria-hidden="true" />6726 Szeged, Közép Kikötő sor 1.</span>
          <span className="text-white/70">Kajak • Kenu • Közösség</span>
        </div>
      </div>
      <div className="mx-auto flex h-[76px] max-w-7xl items-center justify-between px-4 sm:px-6">
        <Link href="/" className="flex items-center gap-3" aria-label="SZVTSZ Vízisport Szakosztály főoldal">
          <Image src="/szvtsz-logo.jpg" alt="SZVTSZ Vízisport Szakosztály" width={128} height={76} priority className="h-14 w-auto object-contain" />
          <span className="hidden border-l border-[#17365d]/15 pl-3 text-sm font-black uppercase leading-tight tracking-[0.06em] text-[#17365d] sm:block">Vízisport<br />Szakosztály</span>
        </Link>
        <nav className="hidden items-center gap-1 xl:flex" aria-label="Fő navigáció">
          {items.map((item) => <Link key={item.href} href={item.href} className="rounded-full px-2 py-2 text-[13px] font-bold text-[#17365d] transition hover:bg-[#eaf2fb] hover:text-[#123ca6] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#123ca6]">{item.label}</Link>)}
        </nav>
        <details className="group relative xl:hidden">
          <summary className="flex size-11 cursor-pointer list-none items-center justify-center rounded-full bg-[#17365d] text-white marker:content-none"><Menu className="size-5" aria-hidden="true" /><span className="sr-only">Menü megnyitása</span></summary>
          <nav className="absolute right-0 top-14 grid min-w-[250px] gap-1 rounded-2xl border border-[#17365d]/10 bg-white p-3 shadow-2xl" aria-label="Mobil navigáció">
            {items.map((item) => { const Icon = item.icon; return <Link key={item.href} href={item.href} className="flex items-center gap-3 rounded-xl px-4 py-3 font-bold text-[#17365d] hover:bg-[#eaf2fb]"><Icon className="size-4 text-[#ef233c]" aria-hidden="true" />{item.label}</Link>; })}
          </nav>
        </details>
      </div>
    </header>
  );
}
